import { isUndefined } from "lodash-es";
import plur from "plur";
import { useState } from "react";

import { Select } from "../Select";
import { TextField } from "../TextField";

const TIME_LIMIT_PRESETS = [1, 2, 5];

export const TimeLimitSelect: React.FC<{ defaultValue?: number | null }> = ({
  defaultValue,
}) => {
  const [timeLimit, setTimeLimit] = useState(
    isUndefined(defaultValue)
      ? "2"
      : defaultValue === null
        ? ""
        : TIME_LIMIT_PRESETS.includes(defaultValue)
          ? defaultValue.toString()
          : "custom",
  );
  return (
    <>
      <Select
        label="Time limit"
        value={timeLimit}
        onChange={(event) => {
          setTimeLimit(event.target.value);
        }}
      >
        <option value="">No limit</option>
        {TIME_LIMIT_PRESETS.map((minutes, index) => (
          <option key={index} value={minutes}>
            {minutes} {plur("minute", minutes)}
          </option>
        ))}
        <option value="custom">Custom</option>
      </Select>
      {timeLimit === "custom" ? (
        <TextField
          required
          label="Custom time limit (minutes)"
          name="timeLimit"
          type="number"
          min={1}
          defaultValue={2}
        />
      ) : (
        <input type="hidden" name="timeLimit" value={timeLimit} />
      )}
    </>
  );
};
